const storageHelper = {
  set(key, value) {
    try {
      const stringValue = JSON.stringify(value);
      localStorage.setItem(key, stringValue);
    } catch (err) {
      console.error("Failed to set item in localStorage:", err);
    }
  },

  get(key) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (err) {
      console.error("Failed to get item from localStorage:", err);
      return null;
    }
  },

  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      console.error("Failed to remove item from localStorage:", err);
    }
  },
};

export default storageHelper;
